import { render, staticRenderFns } from "./TooltipButton.vue?vue&type=template&id=70c244b9&scoped=true&"
import script from "./TooltipButton.vue?vue&type=script&lang=ts&"
export * from "./TooltipButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c244b9",
  null
  
)

export default component.exports